import {CategoryMap, Category} from './categories';

// The manager used to send tracking data. Usually either 'ga' or 'gtag'.
export const TRACKING_SERVICE = 'gtag';

// Following delimiters are considered (url)safe and should avoid most collisions.
// They may be changed only after scrutinizing the existing implementation thoroughly.
export const PARAM_DELIMITER = '|';
export const DATA_DELIMITER = '&&';

// Declare tracking fixtures using the "data-ga-*" attribute.
// Currently, data-ga-click and data-ga-scroll are supported.

// Add tracking data to the attribute using pipe (|) as default delimiter between fields.
// May include multiple event data using double ampersand (&&) as default delimiter.
// Usage example: data-ga-click="usage|click|Show More".

// Map names to labels in order to output readable data to Analytics.
// Can submit unmapped names, but this is not encouraged.
export default new CategoryMap({
	link: new Category('Links', {
		external: 'Ekstern',
		social: 'Social',
		pdf: 'PDF'
	}),
	usage: new Category('Interaktion', {
		click: 'Klik',
		view: 'Se'
	}),
	contact: new Category('Kontakt', {
		mailto: 'Email',
		tel: 'Telefon'
	})
});
